module.exports = __webpack_public_path__ + "assets/202509252035/img/Xavier.95fb1aae.png";